<div class="input_control">
  <label [for]="fieldName">
    {{ label }}
  </label>
  
  <input *ngIf="type !== 'textarea'"
    [ngStyle]="{'height': height + 'px'}"
    [maxlength]="maxlength"
    [placeholder]="placeholder"
    [formControl]="control"
    [type]="type"
    [id]="fieldName"
    [mask]="mask"
    [disabled]="disabled"
    (blur)="blured.emit($event)"
    (input)="inputed.emit($event)"
    (keyup)="keyupped.emit($event)"
  >

  <textarea *ngIf="type === 'textarea'"
    [ngStyle]="{'height': height + 'px'}"
    [maxlength]="maxlength"
    [placeholder]="placeholder"
    [formControl]="control"
    [id]="fieldName"
    [disabled]="disabled"
    (blur)="blured.emit($event)"
    (input)="inputed.emit($event)"
    (keyup)="keyupped.emit($event)">
  </textarea>

  <app-valid-msg
    [control]="control"
    [hint]="hint"
    [fieldName]="fieldName"
    [showIcon]="showIcon">
  </app-valid-msg>
</div>
